import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    QueryList,
    signal,
    SimpleChanges,
} from '@angular/core';

import { NzStepsModule } from 'ng-zorro-antd/steps';
import { IconModule } from '../../modules/icon';
import { StepComponent } from './step.component';
import { startWith, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pf-steps',
    standalone: true,
    imports: [NzStepsModule, IconModule],
    templateUrl: './steps.component.html',
    styleUrl: './steps.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepsComponent implements AfterContentInit, OnChanges, OnDestroy {
    private readonly elementRef = inject(ElementRef<HTMLElement>);

    @Input() currentStep = 0;
    @Input() direction: 'vertical' | 'horizontal' = 'vertical';
    @Input() clickable = false;
    @Output() stepChanged = new EventEmitter<number>();

    @ContentChildren(StepComponent) steps!: QueryList<StepComponent>;

    stepArray = signal<StepComponent[]>([]);

    private readonly destroy$ = new Subject<void>();

    ngAfterContentInit() {
        this.steps.changes
            .pipe(startWith(this.steps), takeUntil(this.destroy$))
            .subscribe((steps: QueryList<StepComponent>) => {
                this.stepArray.set(steps.toArray());
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['currentStep'] && !changes['currentStep'].firstChange) {
            this.scrollCurrentStepIntoView();
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private scrollCurrentStepIntoView() {
        setTimeout(() => {
            const stepElements =
                this.elementRef.nativeElement.querySelectorAll(
                    '.ant-steps-item'
                );
            const activeStep = stepElements[this.currentStep];
            activeStep?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
}
